import { useRef } from "react";
import { TablesStatus } from "./TableStatus";
import UnderConstruction from "./UnderConstruction";

const HomepageBlock = ({ logo, logoAlt = '', city, address, phone, rest, tableData, underConstruction = false, showStatus = true, customStatus = null }) => {
    const blockRef = useRef();

    return(
        <div ref={blockRef}>
            <div>
                { (!underConstruction && showStatus) && <TablesStatus rest={rest} data={tableData} /> }
                { customStatus &&
                    <div className="tableStatus">
                        <div className="statusContent">
                            <div className="statusText">{customStatus}</div>
                        </div>
                    </div>
                }
                <img src={ logo } className="block-logo" alt={logoAlt} />
                <div className="block-text">
                    <h3>{ city }</h3>
                    <div>
                        <p>{ address }</p>
                        { phone && <p>+371 { phone }</p> }
                    </div>
                </div>
            </div>
            { underConstruction && <UnderConstruction parent={blockRef} /> }
        </div>

    )
}

export default HomepageBlock;
